<template>
  <b-card no-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(title)="data">
        {{ data.item.title }}
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <b-button
            variant="outline-primary"
            size="sm"
            :to="$route.path + '/edit/' + data.item.id"
          >
            Güncelle
          </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'footer_contacts'
export default {
  name: 'Index',
  components: {
    BCard,
    BTable,
    BButton,

  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '200px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
        ],
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['footerContacts/dataList']
    },
    dataCounts() {
      return this.$store.getters['footerContacts/dataCounts']
    },
    saveData() {
      return this.$store.getters['footerContacts/dataSaveStatus']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('footerContacts/getDataList', this.dataQuery)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
